import { render, staticRenderFns } from "./combined-stock.vue?vue&type=template&id=658067de&scoped=true"
import script from "./combined-stock.vue?vue&type=script&lang=js"
export * from "./combined-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658067de",
  null
  
)

export default component.exports